import { render, staticRenderFns } from "./Ferramentas.vue?vue&type=template&id=05fffb8a&scoped=true"
import script from "./Ferramentas.vue?vue&type=script&lang=js"
export * from "./Ferramentas.vue?vue&type=script&lang=js"
import style0 from "./Ferramentas.vue?vue&type=style&index=0&id=05fffb8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fffb8a",
  null
  
)

export default component.exports